import { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import Client from "client/Client";
import { getApolloClient } from "client/apolloClient";
import { PaginatedRoomsInfo } from "types/rooms";

type GetRoomSelectorAvailableRoomsByUserSelectionOptions = Parameters<
  typeof Client.GET_ROOMS_DEFAULT_OPTIONS
>[0] & {
  client?: ApolloClient<NormalizedCacheObject>;
};

interface GetRoomSelectorAvailableRoomsByUserSelectionResponse {
  [x: string]: any;
  data: {
    getRoomSelectorAvailableRoomsByUserSelection: {
      __typename: "PaginatedRoomsInfo";
      data: PaginatedRoomsInfo["data"];
      // paginationInfo: PaginatedRoomsInfo["paginationInfo"];
    };
  };
}

export const getAvailableRoomsByUserSelection = async ({
  projectId,
  range,
  filters,
  client = getApolloClient(),
}: GetRoomSelectorAvailableRoomsByUserSelectionOptions) => {
  const newFilters = { ...filters };
  newFilters.additionalRoommatesRanges =
    newFilters.additionalRoommatesRanges?.map((r) => {
      return {
        from: r.from,
        to: r.to,
      };
    });
  const resp = await client.query<{
    getRoomSelectorAvailableRoomsByUserSelection: GetRoomSelectorAvailableRoomsByUserSelectionResponse;
  }>({
    query: Client.GET_AVAILABLE_ROOMS_BY_USER_SELECTION,
    ...Client.GET_ROOMS_DEFAULT_OPTIONS({
      projectId,
      range,
      filters: newFilters,
    }),
  });

  const parsedResponse = {
    data: resp.data.getRoomSelectorAvailableRoomsByUserSelection,
    // paginationInfo: resp.data.getAvailableRoomsByUserSelection.paginationInfo,
  } as unknown as PaginatedRoomsInfo;
  return parsedResponse;
};
